import CheckedSvg from "assets/images/checked.svg";
import { Button, IconType, Motion } from "components/common";
import { PATH_DASHBOARD } from "config";
import Confetti from "react-confetti";
import { useNavigate } from "react-router-dom";
import { getIcon } from "utils/icons";
import type { ReactNode } from "react";

interface SuccessResultProps {
  title: string;
  text?: string;
  hideConfetti?: boolean;
  /** Extra content below the primary message (e.g. secondary CTAs) */
  footer?: ReactNode;
  primaryActionLabel?: string;
  onPrimaryAction?: () => void;
}

export const SuccessResult: React.FC<SuccessResultProps> = ({
  title,
  text,
  hideConfetti,
  footer,
  primaryActionLabel = "Visit Dashboard",
  onPrimaryAction,
}) => {
  const navigate = useNavigate();

  const handlePrimaryAction = () => {
    if (onPrimaryAction) {
      onPrimaryAction();
      return;
    }
    navigate(PATH_DASHBOARD.dashboard);
  };

  return (
    <>
      <img src={CheckedSvg} alt="success" className="w-40 h-40" />

      <Motion className="title-0" property="y" type="div">
        {title}
      </Motion>

      <Motion
        type="div"
        className="mt-12 w-full xs:w-1/2 mx-auto text-regular-1"
        delayValue={0.1}
        property="y"
      >
        {text && (
          <div className="flex flex-col gap-6 ">
            <Motion type="div" delayValue={0.2} property="y">
              {text}
            </Motion>
          </div>
        )}

        {footer && (
          <Motion type="div" delayValue={0.3} property="y" className="mt-6 w-full">
            {footer}
          </Motion>
        )}

        <Motion className="mt-5 px-[10vw]" type="div" delayValue={0.4} property="y">
          <Button onClick={handlePrimaryAction}>
            {primaryActionLabel}
            {getIcon(IconType.Arrow)}
          </Button>
        </Motion>
      </Motion>

      {!hideConfetti && (
        <Confetti
          style={{ pointerEvents: "none" }}
          numberOfPieces={500}
          recycle={false}
          onConfettiComplete={(confetti) => {
            confetti?.reset();
          }}
        />
      )}
    </>
  );
};
